import {
	HttpClient,
	provideHttpClient,
	withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import {
	MAT_DIALOG_DATA,
	MatDialogModule,
	MatDialogRef
} from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserStatesService } from '@brand-lolly/app/services/user-states.service';
import { ToastItemComponent } from '@brand-lolly/app/toast-v2/components/toast-v2/toast-item/toast-item.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AgGridModule } from 'ag-grid-angular';
import {
	DialogService,
	PrimaryButtonComponent,
	SecondaryButtonComponent
} from 'components';
import player from 'lottie-web';
import { ColorPickerDirective } from 'ngx-color-picker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxEchartsModule } from 'ngx-echarts';
import { provideLottieOptions } from 'ngx-lottie';
import { MarkdownModule } from 'ngx-markdown';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { from, Observable } from 'rxjs';
import { HammerModule } from '../../node_modules/@angular/platform-browser';
import { AuthenticationService } from './_services/authentication.service';
import { InterceptorsProvider } from './_services/interceptors/intercepors.provider';
import { SidenavService } from './_services/side-nav.service';
import { UserServiceApi } from './_services/user/user.api.service';
import { AppCustomPreloader } from './app-routing-preloader';
import { MOCK_PROVIDERS } from './providers/mock-providers';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BigcommerceInstallationGuideComponent } from './bigcommerce-installation-guide/bigcommerce-installation-guide.component';
import { MaterialModule } from './material.module';
import { SharedModule } from './shared/shared.module';
import { SidenavModule } from './sidenav/sidenav.module';
import { ToastV2Component } from './toast-v2/components/toast-v2/toast-v2.component';

export class WebpackTranslateLoader implements TranslateLoader {
	public getTranslation(lang: string): Observable<any> {
		return from(import(`../assets/i18n/${lang}.json`));
	}
}
